export default (templateData) => ({
  registrationNumber: templateData?.registrationNumber,
  country: templateData?.country,
  city: templateData?.city,
  postCode: templateData?.postCode,
  address: templateData?.address
});
